import { reactive } from "vue";
import { itemLoadApi, ResponseCode, type Item } from "@src/api";
import { ArrayService } from "@src/services";
import { itemListToMap } from "../model";

const CHUNK_SIZE = 100;

async function itemListLoad(item_ids: string[]): Promise<Item[]> {
  const chunks = ArrayService.chunkArray(item_ids, CHUNK_SIZE);

  const results = await Promise.all(chunks.map((chunk) => itemLoadApi({ item_id: chunk })));

  const all_items: Item[] = [];

  for (const response of results) {
    if (response.code === ResponseCode.OK) {
      all_items.push(...response.items);
    }
  }

  return all_items;
}

export function useItemList() {
  const state = reactive<{ map: Record<string, Item>; is_loading: boolean }>({ map: {}, is_loading: false });

  async function fetch(item_ids: string[]) {
    if (item_ids.length === 0) return;

    state.is_loading = true;

    const item_list = await itemListLoad(item_ids);

    state.map = itemListToMap(item_list);
    state.is_loading = false;
  }

  function isEmpty() {
    return Object.keys(state.map).length === 0;
  }

  return { state, fetch, isEmpty };
}
